import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

const EXAMPLE_REFERENCE_NUMS = {
  Epic: 'FWR-E-15',
  MasterFeature: 'FWR-E-15',
  Feature: 'FWR-12',
  Requirement: 'FWR-12-3',
  Page: 'FWR-N-7',
  Release: 'FWR-R-8',
  MasterRelease: 'FWR-R-8',
  Initiative: 'FWR-S-8',
  Idea: 'FWR-I-23',
  'Ideas::Idea': 'FWR-I-23',
  Goal: 'FWR-G-5',
};

export class ReferenceNum extends Field {
  static attributesForModel() {
    return ['referenceNum'];
  }

  get title() {
    return 'Reference num';
  }

  exampleContents(): FieldContentsData {
    const { typename } = this.recordFields.modelClass;

    if (typename in EXAMPLE_REFERENCE_NUMS) {
      return { text: EXAMPLE_REFERENCE_NUMS[typename], nowrap: true };
    }

    throw new Error(
      `missing example reference num for record type ${typename}`
    );
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: record.referenceNum,
      nowrap: true,
    };
  }
}
